import "./index.less";
import template from "./index.html";
import { EVENT_NEW_FORM } from "../../../constants";

function controller(
	uiState,
	appState,
	eventBus,
	$scope,
	$state
) {

	const ctrl = this;
	ctrl.uiState = uiState;
	ctrl.$state = $state;
	ctrl.$onInit = onInit;

	function onInit() {
		ctrl.forms = appState.forms.items;
		ctrl.form = appState.forms.selected;
		ctrl.permissions = appState.permissions;

		eventBus.register(
			EVENT_NEW_FORM,
			() => {
				ctrl.form = appState.forms.selected;
			},
			$scope
		);

		$scope.$watch(
			() => $state.current.title,
			(title) => {
				if(title) {
					if(typeof title === "string") {
						window.document.title = title;
					}
				}
			}
		);
	}
}

export default angular
	.module("vesl.layout.main-header", [])
	.component("mainHeader", {
		template,
		controller
	}).name;
